import React from 'react';

const SphereRocketLogo = ({ className, alt }) => {
  return (
    <svg
      width="300"
      height="150"
      viewBox="0 0 800 400"
      className={className || "w-full h-auto"}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Earth/Globe */}
      <circle cx="400" cy="200" r="180" fill="#3AA9E0" />
      
      {/* Continents */}
      <path
        d="M280 100 Q320 80 360 120 Q420 140 450 100 Q480 80 520 120 Q540 160 520 220 Q480 280 420 300 Q350 320 300 280 Q250 240 280 180 Z"
        fill="#7ED957"
      />
      <path
        d="M520 220 Q540 260 520 320 Q480 350 450 330 Q420 300 450 260 Q480 240 520 220 Z"
        fill="#7ED957"
      />
      
      {/* Rocket */}
      <g transform="translate(400, 200) rotate(-30) translate(-50, -120)">
        {/* Rocket body */}
        <ellipse cx="60" cy="110" rx="20" ry="70" fill="#E1E1E1" />
        
        {/* Rocket nose */}
        <path d="M60 40 L40 80 L80 80 Z" fill="#D54C3F" />
        
        {/* Window */}
        <circle cx="60" cy="90" r="8" fill="#3AA9E0" />
        
        {/* Fins */}
        <path d="M40 140 L20 160 L40 180 Z" fill="#D54C3F" />
        <path d="M80 140 L100 160 L80 180 Z" fill="#D54C3F" />
        
        {/* Checkered pattern */}
        <rect x="50" cy="110" width="20" height="10" fill="#333" />
        
        {/* Rocket fire */}
        <path d="M50 180 L60 220 L70 180 Z" fill="#F5A623" />
        <path d="M55 180 L60 210 L65 180 Z" fill="#F8E71C" />
      </g>
      
      {/* Text */}
      <g transform="translate(100, 320)">
        <text
          fontFamily="Arial, sans-serif"
          fontSize="72"
          fontWeight="bold"
          fill="#0D2E4C"
        >
          SPHERE ROCKET
        </text>
        <text
          fontFamily="Arial, sans-serif"
          fontSize="36"
          fill="#0D2E4C"
          y="40"
          x="120"
        >
          VIRTUAL ASSISTANTS
        </text>
      </g>
    </svg>
  );
};

export default SphereRocketLogo;